import React from 'react';
import type { SafeVNode } from '@deque/groot';
import { Code } from '@deque/cauldron-react';

interface ElementMarkupProps {
  element: SafeVNode;
}

const ElementMarkup: React.FC<ElementMarkupProps> = ({ element }) => {
  const elementAttributes = ['id', 'role', 'class']
    .map(attribute =>
      element.attributes[attribute]
        ? ` ${attribute}="${element.attributes[attribute]}"`
        : ''
    )
    .join('');
  return <Code>{`<${element.tagName}${elementAttributes}>`}</Code>;
};

export default ElementMarkup;
